export default {
  "": "",
  "24hChange": "24小时涨跌幅",
  "24hTurnover": "24小时交易额",
  "action": "操作",
  "AddLoan": "增加",
  "AdjustLoanFail": "质押资产调整失败，请重试。",
  "all": "全部",
  "apply": "申请",
  "assets": "资产",
  "available": "可用",
  "balance": "可用余额",
  "bi_all": "全部",
  "bi_average_change": "24 小时平均涨跌幅",
  "bi_down_amount": "下跌币种交易量",
  "bi_down_num": "下跌币种",
  "bi_eth_gas": "ETH 矿工费",
  "bi_google_tips": "数值取自 Google 趋势，代表指定时间内搜索热度的最高值，热度最高的字词得 100 分。",
  "bi_google_trends": "Google 趋势上的 BTC 热度",
  "bi_market_cap": "全球加密货币市值 (USDT)",
  "bi_market_distribution": "市值分布",
  "bi_market_sentiment": "市场情绪",
  "bi_market_trends": "加密货币市场行情",
  "bi_market_volatility": "加密货币市场波动性",
  "bi_normal_amount": "持平币种交易量",
  "bi_normal_num": "持平币种",
  "bi_page_title": "实时跟踪加密货币市场行情、情绪和波动性 {'|'} Bybit",
  "bi_price_distribution": "涨跌分布",
  "bi_ranking": "排名",
  "bi_ranking_sector": "按板块排名",
  "bi_ranking_tips": "目前仅显示该板块内市值前 3 的币种。",
  "bi_sentiment1": "极度恐惧",
  "bi_sentiment2": "恐惧",
  "bi_sentiment3": "中立",
  "bi_sentiment4": "贪婪",
  "bi_sentiment5": "极度贪婪",
  "bi_social": "社交媒体热度",
  "bi_td_trade": "交易",
  "bi_th_action": "操作",
  "bi_th_change": "24 小时涨跌幅",
  "bi_th_currency": "币种",
  "bi_th_market": "市值",
  "bi_th_price": "价格",
  "bi_th_sector": "版块",
  "bi_th_up_down": "上涨/下跌",
  "bi_th_volume": "24 小时交易量",
  "bi_top_20": "按市值排名",
  "bi_top_gain": "领涨币种（涨幅）",
  "bi_total_market": "总市值",
  "bi_trading_distribution": "交易量分布",
  "bi_trading_vol": "全球加密货币 24 小时交易量 (USDT)",
  "bi_twitter_explore": "Twitter 探索",
  "bi_twitter_tips1": "Twitter 上近期新出现的加密货币关键词",
  "bi_twitter_tips2": "Twitter 上近期热度较高的加密货币关键词",
  "bi_twitter_topics": "Twitter 热门话题",
  "bi_up_amount": "上涨币种交易量",
  "bi_up_num": "上涨币种",
  "bi_view": "查看",
  "bi_volume_distribution": "交易量变化分布",
  "botValidateErrCode101": "最小价格太低",
  "botValidateErrCode102": "最小价格太高",
  "botValidateErrCode103": "最大价格太低",
  "botValidateErrCode104": "最大价格太高",
  "botValidateErrCode105": "网格数太少",
  "botValidateErrCode106": "网格数太多",
  "botValidateErrCode107": "投资额太低，未满足投资要求。",
  "botValidateErrCode108": "投资额太高，大于合约投资上限。",
  "botValidateErrCode109": "止盈价太低",
  "botValidateErrCode110": "止盈价太高",
  "botValidateErrCode111": "止损价太低",
  "botValidateErrCode112": "止损价太高",
  "botValidateErrCode113": "入场价太低",
  "botValidateErrCode114": "入场价太高",
  "cancel": "取消",
  "cancelAll": "撤销全部",
  "cancelOrder": "撤单",
  "chart": "图表",
  "close": "关闭",
  "confirm": "确认",
  "contest-about-to-start": "即将开始",
  "contest-accumulate-volume": "累计交易量",
  "contest-accumulate-volume-start": "报名成功！您的现货交易量将纳入计算。",
  "contest-achieve-standards": "合格",
  "contest-activity-rules": "活动规则",
  "contest-activity-rules-title": "活动规则",
  "contest-activity-time": "活动时间",
  "contest-countdown": "直至大赛结束",
  "contest-countdown-day": "天",
  "contest-cumulative-volume": "交易总量（{unit}）",
  "contest-current-volume": "当前交易量",
  "contest-date-range": "{month}  {date} 日 {time} {utc} ",
  "contest-dialog-btn-text": "确认",
  "contest-difference-to-foward": "距离前一排名只差 {num} {unit}",
  "contest-earn-rewards": "奖励（{unit}）",
  "contest-ended": "活动已结束",
  "contest-find-more-premium-assets": "在现货平台继续交易！",
  "contest-latest-update": "数据将于 {time}{utc} 更新。",
  "contest-less": "隐藏",
  "contest-limit-desc": "您需要达到最低现货交易量 {amount} {unit}，方可领取奖励。",
  "contest-list-show-more": "展示更多",
  "contest-login": "登录",
  "contest-month": "1 月,2 月,3 月,4 月,5 月,6 月,7 月,8 月,9 月,10 月,11 月,12 月",
  "contest-my-rank": "我的排名",
  "contest-no-rank": "暂无排名。敬请关注！",
  "contest-no-rank-yet": "暂无排名",
  "contest-not-registered": "您没有报名参加本次交易大赛",
  "contest-num-of-participants": "参与人数",
  "contest-popup-success": "立即交易",
  "contest-ranking": "排名",
  "contest-register": "立刻报名",
  "contest-registered": "已报名",
  "contest-registration-ends": "报名结束",
  "contest-rewards-earned": "奖励（{unit}）",
  "contest-share": "分享",
  "contest-symbol-scope": "现货交易对",
  "contest-terms-conditions": "<p>条款和条件</p>",
  "contest-to-spot-trade": "活动已开始。立即充值和交易！",
  "contest-u-earned-king": "您已获得“超级交易者”奖励",
  "contest-u-earned-sunny": "您已获得“顶级交易者”奖励",
  "contest-unqualified": "很遗憾，您没有参与资格。如有任何疑问，请联系我们的客服团队。",
  "contest-updated-daily-at": "* 最近更新时间为 {time}（UTC0）。",
  "contest-will-start-tips": "报名成功！活动将于 {time} 开始。敬请关注！",
  "contest-your-rewards": "您符合领奖资格",
  "contract_account": "合约账户",
  "createErrorCode400": "用户发送的数据包含非法参数。有关更多信息，请查看错误消息和错误详情。",
  "createErrorCode401": "余额不足。",
  "createErrorCode402": "用户创建的机器人数量已达上限。",
  "createErrorCode403": "服务禁用",
  "createErrorCode404": "所请求资源未找到。",
  "createErrorCode407": "该用户类型不支持创建机器人子账户。",
  "createErrorCode408": "选择了重复定投标的",
  "createErrorCode409": "最大投资额无效",
  "createErrorCode410": "最大投资额无效",
  "createErrorCode411": "机器人已被关闭",
  "createErrorCode412": "统一保证金账户升级中",
  "createErrorCode500": "服务器内部错误",
  "createErrorCode501": "内部处理超时",
  "createErrorCode503": "当前定投机器人无法关闭，可能正在进行定投买入。",
  "currency": "币种",
  "dailyRate": "日利率",
  "deposit": "充值",
  "detail": "详情",
  "direction": "方向",
  "end": "结束时间",
  "fiat": "法币",
  "filled": "已成交",
  "filter": "筛选",
  "from": "开始时间",
  "global_setting_quick_order_desc": "<p>1. 市价单（快捷下单）</p>\n<p>2. 请注意，填写的购买数量可能与输入的订单数量略有不同。</p>",
  "global_setting_quick_order_label": "快捷下单",
  "global_setting_title": "自定义设置（适用于现货）",
  "hint": "提示",
  "innovateQuota": "可用额度",
  "kline": "K线",
  "l_version_tip": "当前版本不支持Launchpad活动，请更新至最新版！",
  "LastTradedPrice": "最新价",
  "leverage": "杠杆倍数",
  "leverage_can_borrow": "支持借币",
  "leverage_can_deposit": "支持保证金",
  "leverage_data": "杠杆数据",
  "leverage_forced_order": "强平顺序",
  "leverage_go_trade": "立即交易",
  "leverage_loan_limit": "借贷限额",
  "leverage_min_borrow": "借贷下限",
  "leverage_off_trade_tip": "请开启杠杆，然后参与杠杆交易。",
  "leverage_yearly_rate": "年利率",
  "leverageCloseErrInfo": "操作失败！您需要还清全部欠款后，才能关闭杠杆交易。",
  "leverageCloseTips": "操作失败！您的账户存在进行中的杠杆订单。",
  "leverageLoanTips": "操作失败！您的统一保证金账户的 IM 或 MM 占用率已超过预警值。",
  "leverageLP_banner_title": "Bybit 现货杠杆交易",
  "leverageLP-banner-desc": "借币交易，赚取更高收益。",
  "leverageLP-faq-a1": "完整列表请参见<a href=\"{url}\" target=\"_blank\" >杠杆交易的抵押资产与可借贷资产清单</a>。",
  "leverageLP-faq-a10": "请点击“订单 → 现货订单→ 还款历史 → 强平”，查看强平记录。",
  "leverageLP-faq-a11": "请点击“订单 → 现货订单→ 还款历史”，查看您的借贷与还款记录。",
  "leverageLP-faq-a2": "Bybit 杠杆交易会产生现货交易手续费、利息与强平费。欲了解详情，敬请阅读<a href=\"{url}\" target=\"_blank\" >Bybit 现货杠杆交易：手续费概览与明细</a>。",
  "leverageLP-faq-a3": "杠杆交易直接通过 Bybit 现货账户进行。",
  "leverageLP-faq-a4": "不可以。开通机构借贷的用户无法参与杠杆交易。如需将您的 UID 从机构借贷用户名单中移除，请发送邮件至 institutional_services{'@'}bybit.com。",
  "leverageLP-faq-a5": "不同 VIP 等级的借贷利率不同。详情请参见<a href=\"{url}\" target=\"_blank\" >杠杆交易数据</a>。",
  "leverageLP-faq-a6": "利息按小时计算。请注意，不足 1 小时也将按 1 小时计算。",
  "leverageLP-faq-a7": "您将通过短信与邮件收到 2 次风险通知：\n\n(1) 现货账户的风险等级 ≥ 87% - 触发风险警报，系统发送短信与邮件通知，提醒您追加抵押品（转入更多抵押资产）以防强平。\n\n(2) 现货账户的风险等级 ≥ 95%，您将收到短信与邮件形式的强平警报，通知仓位已被强平。\n\n有关强平流程与指标的详情，敬请参见<a href=\"{url}\" target=\"_blank\" >现货杠杆交易的风险与强制平仓</a>。",
  "leverageLP-faq-a8": "杠杆交易保险基金 (MAF) 用于抵消用户在强平后因账户资金不足以偿还贷款所造成的穿仓损失。\n\n如果现货账户资不抵债，平台将使用这项基金来偿还债务。因此，用户需要缴纳强平费，补充杠杆交易保险基金。",
  "leverageLP-faq-a9": "所有保证金用于偿还贷款后，倘若还有欠款，则由杠杆交易保险基金承担损失。",
  "leverageLP-faq-q1": "哪些币种可作为杠杆交易的抵押品或可借贷资产？",
  "leverageLP-faq-q10": "在哪里查看强平记录？",
  "leverageLP-faq-q11": "在哪里查看借贷与还款记录？",
  "leverageLP-faq-q2": "Bybit 杠杆交易是否收取手续费？",
  "leverageLP-faq-q3": "参与杠杆交易时，应该使用哪个账户？",
  "leverageLP-faq-q4": "开通机构借贷后，能否参与杠杆交易？",
  "leverageLP-faq-q5": "Bybit 杠杆交易的借贷利率是多少？",
  "leverageLP-faq-q6": "多长时间开始计息？",
  "leverageLP-faq-q7": "在什么情况下，我会收到杠杆交易的风险通知？",
  "leverageLP-faq-q8": "什么是杠杆交易保险基金？",
  "leverageLP-faq-q9": "遭到强平后，如果现货账户资不抵债会如何？",
  "leverageLP-faq-title": "常见问题解答",
  "leverageLP-feature-title": "杠杆交易有哪些优势？",
  "leverageLP-feature1": "交易收益倍增",
  "leverageLP-feature2": "支持做多/做空交易",
  "leverageLP-feature3": "提高资金利用率",
  "leverageLP-feature4": "资产多元化",
  "leverageLP-whats-leverage": "什么是现货杠杆交易？",
  "leverageLP-whats-leverage-c": "Bybit 的现货杠杆交易是现货交易的衍生产品。您可以抵押现货账户中的资产，从 Bybit 借贷资金，然后在现货市场中通过杠杆放大潜在收益。",
  "leverageTest": "杠杆交易测试",
  "leverageTestSubTitle": "答对全部题目才可以开始杠杆交易。",
  "leverageTryAgain": "系统异常，请您稍后重试！",
  "liquidate": "已强制平仓",
  "liquidationErrorInfo": "操作失败！账户已触发强制平仓。",
  "load_more": "加载更多",
  "loan": "借款",
  "loan_limit": "借款期限",
  "loan_spot_account": "现货账户",
  "loanLualityDeposit1": "只有当前质押率小于初始质押率时，方可减少质押资产。",
  "loanLualityDeposit2": "可减少的质押数量上限是达到初始质押率的数量。",
  "loanLualityDeposit3": "若当前质押率大于等于初始质押率，则不允许减少质押资产。",
  "loanTime": "借款时间",
  "login": "登录",
  "lp_go_home": "返回",
  "lpn_one_progress_info": "结果预期公布于",
  "lpn_order_btn": "我的认购",
  "lpn_order_btn_cancel": "取消",
  "lpn_order_btn_confirm": "确认",
  "lpn_order_submit_error": "操作失败！",
  "lpn_order_submit_error_desc": "系统错误。点击重试。",
  "lpn_unfold": "了解更多",
  "lt_all": "全部",
  "lt_amount": "金额",
  "lt_amount_not_enough": "您的 {currency} 可用余额不足！",
  "lt_entry_tips": "{symbol} 支持杠杆代币{direction}交易，立即交易！",
  "lt_freerate": "费率",
  "lt_lowcase_redemption": "赎回",
  "lt_lowcase_subscription": "申购",
  "lt_open_success_txt": "恭喜，您已成功启用杠杆代币！",
  "lt_orders_submitted": "{ordertype} {quantity} 的订单已成功提交。",
  "lt_redemption": "赎回",
  "lt_redemption_failed_change_position": "当前交易对正在调仓，无法赎回，请稍后再试。",
  "lt_redemption_failed_closed": "该资产当前已关闭赎回，请稍后再试。",
  "lt_redemption_failed_input_quantity": "请输入赎回数量",
  "lt_redemption_failed_net_worth": "当前资产净值错误，无法赎回，请稍后再试。",
  "lt_redemption_failed_wear_position": "您的账户正在强平中，无法赎回，请稍后再试。",
  "lt_redemption_max_quanlity": "该资产的单笔最大赎回金额不得大于 {quantity}。",
  "lt_redemption_min_quanlity": "该资产的单笔最小赎回金额不得小于 {quantity}。",
  "lt_redemption_tips": "实际赎回金额以最终成交结果为准。",
  "lt_subscription": "申购",
  "lt_subscription_failed_change_position": "当前交易对正在调仓，无法申购，请稍后再试。",
  "lt_subscription_failed_close_position": "您的账户正在强平中，无法申购，请稍后再试。",
  "lt_subscription_failed_closed": "该资产当前已关闭申购，请稍后再试。",
  "lt_subscription_failed_input_amount": "请输入申购数量",
  "lt_subscription_failed_invalid_value": "当前资产净值错误，无法申购，请稍后再试。",
  "lt_subscription_failed_large_amount": "申购金额过高会导致全仓风险率升高，面临强平风险。",
  "lt_subscription_failed_wear_position": "您的账户已穿仓，无法申购，请稍后再试。",
  "lt_subscription_max_amount": "该资产的单笔最大申购金额不得大于 {amount}。",
  "lt_subscription_min_amount": "该资产的单笔最小申购金额不得小于 {amount}。",
  "lt_subscription_redemption": "申购和赎回",
  "lt_subscription_redemption_records": "申购和赎回记录",
  "lt_subscription_tips": "实际申购金额以最终成交结果为准。",
  "lt_subscription_usdt_not_enough": "您的 USDT 可用余额不足！请先充值或转入。",
  "lt-landing-banner-desc": "自带杠杆，无强平风险",
  "lt-landing-banner-title": "Bybit 杠杆代币",
  "lt-landing-faq-a1": "NAV（全称“资产净值”）是指杠杆代币的价值。杠杆代币的 NAV 随永续合约市场的价格波动而变化。",
  "lt-landing-faq-a2": "以 BTC 为例：\n\nBTC3L 指 3 倍看多 BTC。\n\nBTC3S 指 3 倍看空 BTC。",
  "lt-landing-faq-a3": "杠杆代币交易直接通过 Bybit 现货账户进行。",
  "lt-landing-faq-a4": "敬请参见<a href=\"{url}\" target=\"_blank\" >杠杆代币与衍生品交易的区别</a>。",
  "lt-landing-faq-a5": "敬请参见 <a href=\"{url}\" target=\"_blank\" >Bybit 杠杆代币：手续费概览</a>。",
  "lt-landing-faq-a6": "没有强平风险。\n\n以 BTC3L 为例，调仓触发阈值为 [2,4]。当实际杠杆率 ≥ 4 倍或 ≤ 2 倍时，触发调仓机制，重新调整为 3 倍的目标杠杆。\n\n注：杠杆代币的资产净值可能归零，归零后无法恢复。",
  "lt-landing-faq-a7": "调仓机制是指根据目标杠杆，灵活调整标的资产的永续合约仓位。实际杠杆倍数在超出一定区间后将自动触发调仓。\n\n欲了解详情，敬请参见 <a href=\"{url}\" target=\"_blank\">Bybit 杠杆代币调仓机制</a>。",
  "lt-landing-faq-a8": "平台暂不支持提币。",
  "lt-landing-faq-q1": "什么是资产净值 (NAV)？",
  "lt-landing-faq-q2": "杠杆代币的名称代表什么？",
  "lt-landing-faq-q3": "Bybit 的杠杆代币交易使用哪种账户？",
  "lt-landing-faq-q4": "Bybit 的杠杆代币与衍生品交易有何不同？",
  "lt-landing-faq-q5": "杠杆代币涉及哪些手续费？",
  "lt-landing-faq-q6": "我的杠杆代币仓位是否会被强平？",
  "lt-landing-faq-q7": "什么是调仓机制？",
  "lt-landing-faq-q8": "杠杆代币是否支持提币？",
  "lt-landing-faq-title": "常见问题解答",
  "lt-landing-feature-title": "杠杆代币的优势",
  "lt-landing-feature1": "自带杠杆，放大收益",
  "lt-landing-feature2": "无强平风险",
  "lt-landing-feature3": "高效利用资金",
  "lt-landing-feature4": "交易方便快捷",
  "lt-landing-learn-more": "了解详情",
  "lt-landing-operation": "操作",
  "lt-landing-symbol": "交易对",
  "lt-landing-whats-lt": "什么是杠杆代币？",
  "lt-landing-whats-lt-c": "杠杆代币是一种新型金融衍生品，用户无需缴纳保证金即可通过自带杠杆属性获得高额收益，无强制平仓风险。\n\n每种杠杆代币代表一系列永续合约仓位。\n\n杠杆代币的资产净值 (NAV) 随永续合约市场的价格波动而变化。",
  "lt-learning-video-title": "杠杆代币新手教学视频",
  "ltLearningVideo": "视频教程",
  "ltNav": "资产净值",
  "ltOpenRiskContent": "您可通过杠杆代币对基础资产的杠杆版本进行投资。Bybit 保留根据市场情况自行调整服务条款、采取以下任意行动且无需事先通知的权利：\n1.根据市场情况移除相关交易对。\n2.施加产品限制，例如持仓限额，具体持仓限额数值会根据市场情况做出相应调整，请关注官方公告。由于技术原因等可能会对持仓限额的计算造成一定差异，请熟知相关风险。\n3.根据市场情况相应调整仓位。\n4.终止与杠杆代币相关的服务条款。\n您有责任随时了解我们关于该产品的公告。在继续之前，您应该阅读并理解我们的风险披露和产品机制。Bybit 不承担与杠杆代币相关的任何损失和风险。选择继续，您被视为已阅读、理解并同意我们的<a href={url} target=\"_blank\">服务条款</a>。",
  "ltOpenRiskSubmit": "我同意签署本协议并开通杠杆代币服务",
  "ltOpenRiskTitle": "杠杆代币服务协议",
  "ltTestDialogContent": "您确定退出测试吗？中途退出已做题目不会保存",
  "ltTestDialogContinue": "继续答题",
  "ltTestDialogExit": "确定退出",
  "ltTestDialogTitle": "提示",
  "ltTestDone": "您已完成<span>{num}/{numAll}</span>道题目",
  "ltTestDoneFail": "您共答对{num}/{numAll}道题目，测试未通过，请重新作答",
  "ltTestPassContent": "恭喜，您已通过测验！",
  "ltTestPassRead": "了解更多",
  "ltTestPassReject": "不用了",
  "ltTestResubmit": "重新作答",
  "ltTestSubmit": "提交答案",
  "ltTestSubTitle": "答对全部题目才可以开始杠杠代币产品交易",
  "ltTestTitle": "风险测试",
  "ltUnderlying": "跟踪标的",
  "margin_coin": "币种",
  "margin_discount": "折算率",
  "margin_discount_eg": "举例：",
  "margin_discount_eg_body": "假设账户内有 BTC 和 XRP 作为杠杆保证金，用户账户内有 1 BTC、50 XRP，假设此时 BTCUSDT 的市场价格为 50,000。因为 50 XRP 的币种折算率为 0；1 BTC 的价值处于 0~5,000,000 USDT 之间，BTC 的币种折算率为 1，则账户的 USDT 价值为 50,000 * 1 * 1 = 50,000 USDT。",
  "margin_discount_rate": "币种折算率",
  "margin_lq_order": "强平顺序",
  "MARKET": "市场价格",
  "max": "最大",
  "more": "更多",
  "network_error": "请求失败，请稍后重试。",
  "NEW": "待成交",
  "nextPage": "下一页",
  "nodata": "暂无数据",
  "none": "无",
  "noRecordFound": "暂无记录",
  "og_description": "加入 Bybit 现货交易平台，安心买卖和交易 {symbol}。坐享低手续费和高流动性，开启全新交易体验。",
  "og_title": "{symbol} {'|'} 买卖交易，尽享低手续费 {'|'} Bybit 现货",
  "ol_agree": "我已阅读并同意",
  "ol_agrmt": "数字资产借贷协议",
  "ol_agrmt_2": "《数字资产借贷协议》",
  "ol_agrmt_err": "必须签署《数字资产借贷协议》",
  "ol_amt": "借贷金额",
  "ol_amt_err": "{condition} 借贷金额为 {amount} {unit}",
  "ol_amt_tip": "请输入借贷金额",
  "ol_app_sub": "借贷申请已提交",
  "ol_app_time": "申请时间",
  "ol_apply_title": "机构借贷线上申请",
  "ol_cancel": "您是否放弃本次申请？",
  "ol_cfm_product": "机构借贷产品",
  "ol_check_app": "查询申请",
  "ol_coin": "币种",
  "ol_col_amt": "金额",
  "ol_col_app_tm": "申请时间",
  "ol_col_dl": "借贷期限",
  "ol_col_no": "订单号",
  "ol_col_pn": "产品名称",
  "ol_col_sub": "子账户",
  "ol_confirm": "借贷申请确认",
  "ol_contact_desc": "请务必填写正确的联系方式，邮箱和手机号将会接收风控警报。",
  "ol_contact_tip": "请联系商务团队",
  "ol_contact_title": "联系方式",
  "ol_detail_title": "借贷申请详情",
  "ol_eg": "示例",
  "ol_email": "邮箱",
  "ol_email_err_invalid": "邮箱地址无效",
  "ol_email_tip": "请填写您的邮箱地址",
  "ol_max": "maximum",
  "ol_mgr": "专属客户经理 ID",
  "ol_mgr_err_invalid": "客户经理 ID 无效",
  "ol_mgr_link": "点击获取专属客户经理 ID",
  "ol_mgr_tip": "请输入专属客户经理的 ID",
  "ol_min": "minimum",
  "ol_mine_title": "我的借贷申请",
  "ol_month": "{month} 个月",
  "ol_no_code_rcd": "未搜索到相关国家编号",
  "ol_notice_desc": "<li>机构借贷业务仅向机构交易者开放</li>\n<li>申请借贷的机构交易者，所持资产不得小于 50 万 USDT</li>\n<li>根据用户所选产品，借贷资金可应用于现货市场或合约市场</li>",
  "ol_notice_desc_lmt": "<li>最小申请借贷金额为 100 万 USDT，最大申请借贷金额为 2000 万 USDT。</li>",
  "ol_notice_title": "机构借贷须知",
  "ol_phone": "手机号",
  "ol_phone_err": "请选择区号并填写手机号",
  "ol_phone_err_invalid": "手机号码格式无效",
  "ol_phone_tip": "请输入您的手机号",
  "ol_prd": "请选择机构借贷产品",
  "ol_prd_3x_spot": "机构借贷：3 倍杠杆（现货）",
  "ol_prd_3x_spot_futures": "机构借贷：3 倍杠杆（现货和衍生品）",
  "ol_prd_5x_spot": "机构借贷：5 倍杠杆（现货）",
  "ol_prd_link": "了解产品详情",
  "ol_prd_tip": "如果现货账户资产兑换成非保证金资产，则面临强平风险。敬请点击<a href={url} target=\"_blank\">此处</a>，详细了解 Bybit 现货市场支持的保证金资产。",
  "ol_recent_year_only": "仅支持查询近 1 年的借贷申请",
  "ol_status": "申请状态",
  "ol_status_list": "全部, 已受理,申请确认, 申请拒绝, 已放款",
  "ol_subacc": "关联子账户",
  "ol_subacc_tip": "请输入待关联子账户的 UID。如果数量很多，请联系商务团队。",
  "ol_term": "借贷期限",
  "ol_term_err": "请选择申请借贷的期限。",
  "ol_unit_month": "单位：月",
  "ol_view_agrmt": "查看协议附件",
  "operationSuccess": "成功",
  "or": "或",
  "orderBook": "订单表",
  "orderHistory": "订单历史",
  "orderId": "订单单号",
  "orderSuccessful": "订单提交成功",
  "orderType": "订单类型",
  "otcErrorInfo": "抱歉，您开通了机构借贷，无法进行杠杆交易。",
  "outstanding": "待还",
  "pa_accumated_profit_descript": "累计收益额是指在一定时间段内的每日收益额之和；累计收益额图表仅显示截至前一天的数据。",
  "pa_accumated_profit_select": "当前累计收益额",
  "pa_accumated_profit_title": "累计收益额",
  "pa_accumulated_account": "现货账户累计收益率",
  "pa_accumulated_btc": "BTC 价格累计涨跌率",
  "pa_accumulated_btc_select": "当前 BTC 价格累计涨跌率",
  "pa_accumulated_pnl": "7 日盈亏",
  "pa_accumulated_pnl_select": "当前累计收益率",
  "pa_accumulated_roi_descript": "累计收益率是指在一定时间段内的整体盈利效率；累计收益率图表仅显示截至前一天的数据。",
  "pa_accumulated_roi_title": "累计收益率",
  "pa_assets_distribution_descript": "资产分布是指现货账户中各个币种折算成 USDT 后，所得估值在总资产估值中的占比。",
  "pa_assets_distribution_title": "资产分布",
  "pa_daily_pnl": "今日盈亏",
  "pa_daily_profit_descript": "每日盈亏图表仅显示截至前一天的数据。",
  "pa_daily_profit_select": "当日盈亏",
  "pa_daily_profit_title": "每日盈亏",
  "pa_last_30_day": "最近 30 天",
  "pa_last_7_day": "最近 7 天",
  "pa_last_90_day": "最近 90 天",
  "pa_others": "其他",
  "pa_page_description": "实时掌握资产状况，及时调整投资策略，强占投资先机！",
  "pa_page_title": "现货资产盈亏分析",
  "pa_quantity": "{Coin} 数量",
  "pa_spot_pnl_descript": "1. 现货盈亏分析数据每天 0:00 (UTC) 起开始更新。\n2. 最新现货盈亏分析数据更新计算时间为每天 0:00-6:00 (UTC)，更新后的数据将于 6:00 (UTC) 后显示。",
  "pa_spot_pnl_title": "现货盈亏分析",
  "pa_total_assets": "总资产",
  "pa_total_assets_value_descript": "总资产估值是指现货账户中所有资产的估值总和（含借入资产），充值、提币、转入转出、借贷以及杠杆交易等行为均会影响总资产估值。",
  "pa_total_assets_value_select": "资产估值",
  "pa_total_assets_value_title": "总资产估值",
  "pa_update_on": "最近更新时间：",
  "pa_value": "{Coin} 估值",
  "pa_weightage": "{Coin} 占比",
  "pauseTradeTip": "{symbol} 目前暂时无法交易。敬请参阅我们的<a href={url} target=\"_blank\">博客</a>，了解详情。",
  "placeHolder": "请选择",
  "prevPage": "上一页",
  "price": "价格",
  "quantity": "数量",
  "ReduceLoan": "减少",
  "ReduceLoanAssets": "减少质押资产",
  "ReduceLoanTip1": "不能减少质押资产，只有当前质押率小于初始质押率时才能减少质押资产。",
  "ReduceLoanTip2": "不能减少质押资产，减少的数量需小于质押资产可减数量。",
  "ReduceLoanTip3": "不能减少质押资产，减少的数量需小于质押资产可减数量，请重试。",
  "ReduceLoanTip4": "您可以在订单页面调整质押金，您可以随时添加更多质押金，若当前质押率小于初始质押率时，还可以减少质押资产。",
  "repayment": "还款",
  "reset": "重置",
  "reverse_contract_account": "反向合约账户",
  "riskWarning": "确认弹窗",
  "search": "搜索",
  "side": "方向",
  "signup": "注册",
  "spot_account": "现货账户",
  "status": "状态",
  "stop_limit": "止盈止损",
  "stop_limit_tips_2": "当前有止盈止损委托单，暂不支持开启杠杆交易。",
  "success": "成功",
  "sure": "sure",
  "tests1": "",
  "times": "次",
  "timestamp": "时间",
  "title_404": "404 {'|'} Bybit 现货交易平台  ",
  "to": "至",
  "toastTheSymbolNotExist": "抱歉！您选择的交易对暂无法访问",
  "total": "累计",
  "tradeChange": "涨跌幅",
  "tradeId": "成交号",
  "transfer": "划转",
  "usdc_contract_account": "USDC 合约账户",
  "VIP99": "至尊 VIP",
  "volume": "已成交量",
  "vote_btn_trade": "交易"
}